import clsx from 'clsx'
import { ReactNode } from 'react'

import { Flex } from 'components/common/flex/Flex'

import styles from './Button.module.scss'

interface Props {
  text: string
  iconLeft?: ReactNode
  iconRight?: ReactNode
  variant?:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'black'
    | 'transparentBg'
    | 'navigationControl'
    | 'navigationControlWhite'
    | 'navigationControlBlack'
    | 'navigationControlHoverWhite'
  small?: boolean
  onClick?: () => void
  border?: boolean
  className?: string
  fontClassName?: string
}
export const Button = ({
  text,
  iconLeft,
  iconRight,
  variant = 'primary',
  small = false,
  border,
  onClick = () => {},
  className,
}: Props) => {
  return (
    <Flex
      className={clsx(
        styles.flexBaseWidth,
        styles[variant],
        small && styles.small,
        styles.button,
        border && styles.border,
        className,
      )}
      inline
      align="center"
      gap={8}
      onClick={() => onClick()}
    >
      {iconLeft && <div className={styles.icon}>{iconLeft}</div>}
      <div className={styles.fontClassName}>{text}</div>
      {iconRight && <div className={styles.icon}>{iconRight}</div>}
    </Flex>
  )
}
